import { SxProps } from '@mui/material/styles';

export const drawerSX: SxProps = {
	// color: 'primary.contrastText',
	// backgroundColor: 'primary.main',
};
